import { render, staticRenderFns } from "./pipelines_artifacts.vue?vue&type=template&id=81f4b2ee&"
import script from "./pipelines_artifacts.vue?vue&type=script&lang=js&"
export * from "./pipelines_artifacts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "pipelines_artifacts.vue"
export default component.exports